<template>
  <div
    :class="{ 'form-popup-overlay': true, 'is-visible': isVisible, 'px-5': true }"
    @click="hide">
    <div
      :class="{ 'form-popup': true, 'px-5': true, 'pb-4': true, 'pt-4': true, 'is-loading': loading || !loaded }"
      @click.stop>
      <h3 class="text-center">
        Select checklist template
      </h3>

      <validation-observer ref="checklist-templates-form" tag="form">
        <d-row>
          <div class="form-group w-100">
            <validation-provider
              rules="required"
              name="id"
              v-slot="{ errors }">
              <label for="id">Airport:</label>
              <div :class="{ 'form-control': true, 'is-select': true }">
                <v-select
                  :options="templates"
                  v-model="data.id"
                  :reduce="template => template.id"
                  :filterBy="filterByTemplates"
                  placeholder="Select a template"
                  label="name">
                  <template slot="no-options">
                    <template v-if="!emptyResults">Search in progress&hellip;</template>
                    <template v-if="emptyResults">There are no templates for the provided phrase&hellip;</template>
                  </template>
                  <template slot="option" slot-scope="option">
                    <div class="d-center">
                      {{ option.name }}
                    </div>
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="selected d-center">
                      {{ option.name }}
                    </div>
                  </template>
                </v-select>
              </div>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </d-row>
      </validation-observer>

      <d-row>
        <div class="text-center w-100">
          <d-button
            @click.prevent="validateForm"
            theme="success"
            class="mr-5">
            Save
          </d-button>

          <d-button
            @click.prevent="cancel"
            outline
            theme="secondary">
            Cancel
          </d-button>
        </div>
      </d-row>
    </div>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils';

export default {
  name: 'ChecklistTemplatesPopup',
  data () {
    return {
      isVisible: false,
      loaded: false,
      loading: false,
      templates: [],
      emptyResults: false,
      loadError: false,
      data: {
        id: null,
        reference_id: null,
        reference_type: null
      }
    };
  },
  mounted () {
    this.$bus.$on('show-checklist-templates-popup', this.show);
    this.$bus.$on('checklist-templates-reload', this.loadData);
  },
  methods: {
    loadData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/check-list-templates/items',
        params: {
          pagination: 0
        },
        outputKey: 'templates',
        loadedKey: 'loaded',
        errorKey: 'loadError'
      });
    },
    filterByTemplates (option, label, search) {
      return option.name.toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    show (referenceType = false, referenceId = false) {
      this.loaded = false;
      this.loadData();

      this.data = {
        id: null,
        reference_id: referenceId,
        reference_type: referenceType
      };

      setTimeout(() => {
        this.isVisible = true;
        this.$refs['checklist-templates-form'].reset();
      }, 100);
    },
    validateForm () {
      FormUtils.validate(this.$refs['checklist-templates-form'], this.submitForm);
    },
    submitForm () {
      this.loading = true;
      let endpointUrl = '/check-list-templates/copy-items/' + this.data.id;
      let formDataToSend = this.prepareFormData();

      FormUtils.submit({
        $http: this.$http,
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Items added',
        successText: '',
        errorTitle: 'An error occurred',
        errorText: 'The system was unable to add items from the selected template. Please try again.',
        successAction: () => {
          this.loading = false;
          this.isVisible = false;
          this.$bus.$emit('checklist-list-reload');
          this.$refs['checklist-templates-form'].reset();
        }
      });
    },
    cancel () {
      this.isVisible = false;
      this.loading = false;
    },
    hide () {
      this.isVisible = false;
      this.loading = false;
    },
    prepareFormData () {
      let dataToSend = {
        reference_id: this.data.reference_id,
        reference_type: this.data.reference_type
      };

      return dataToSend;
    }
  },
  beforeDestroy () {
    this.$bus.$off('show-checklist-templates-popup', this.show);
    this.$bus.$off('checklist-templates-reload', this.loadData);
  }
}
</script>
